module.exports = __webpack_public_path__ + "static/img/17041B_1_R_20211024_fit.214739b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17041B_1_R_20211024_fit.png
// module id = tXx3
// module chunks = 0